var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#FD4C5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1607 19.0107C40.3615 19.0428 40.5543 19.1362 40.7091 19.2909C40.9969 19.5788 41.0726 19.9985 40.9361 20.3557L33.9443 40.3323C33.8088 40.7193 33.4508 40.9844 33.0412 41.0011C32.6315 41.0178 32.2531 40.7828 32.0866 40.4081L28.242 31.7578L19.5917 27.9132C19.217 27.7466 18.9819 27.3683 18.9986 26.9586C19.0154 26.5489 19.2805 26.1909 19.6675 26.0555L39.6581 19.0588C39.6938 19.0457 39.7301 19.0348 39.7667 19.026C39.8974 18.9943 40.0313 18.9898 40.1607 19.0107ZM36.1965 22.3893L22.7089 27.11L28.7783 29.8075L36.1965 22.3893ZM30.1924 31.2218L37.6102 23.804L32.8898 37.2909L30.1924 31.2218Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.1712b7c920c379db4ada1ee076be87d6.svg";
export { ForwardRef as ReactComponent };